import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-26/task-01";

const task: Slide = {
  title: "Connect figures with correct coil configuration.",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
